import React from 'react';
interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
}
export function Eyebrow({
  children,
  className = ''
}: EyebrowProps) {
  return <p className={`text-[12px] font-extrabold uppercase leading-none tracking-[0.22em] text-brand-orange ${className}`} data-id="element-41" data-mp="1pp3z50fu3fl6">
      {children}
    </p>;
}